import { render, staticRenderFns } from "./IniciarAtendimento.vue?vue&type=template&id=46ddea42"
import script from "./IniciarAtendimento.vue?vue&type=script&lang=js"
export * from "./IniciarAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports